const Menu = [
  {
    header: 'Início',
    items: [{ title: 'Dashboard', icon: 'dashboard', route: 'dashboard-index', roles: true }]
  },
  {
    header: 'Gerencial',
    items: [
      {
        title: 'Controle',
        icon: 'domain_verification',
        route: 'controle-index',
        roles: true
      },
      {
        title: 'Visitas',
        icon: 'transfer_within_a_station',
        route: 'visitas-index',
        roles: true
      },
      { title: 'Balancetes', icon: 'poll', route: 'balancetes-index', roles: true },
      { title: 'Laudos', icon: 'ballot', route: 'laudos-index', roles: true },
      { title: 'Relatórios', icon: 'print', route: 'relatorios-index', roles: true },
      {
        title: 'Documentos',
        icon: 'insert_drive_file',
        route: 'documentos-index',
        roles: true
      }
    ]
  },
  {
    header: 'Cadastro',
    items: [
      {
        title: 'Clientes',
        icon: 'contacts',
        route: 'clientes-index',
        offline: false,
        roles: true
      },
      {
        title: 'Industrias',
        icon: 'apartment',
        route: 'industrias-index',
        offline: false,
        roles: ['admin', 'auxiliar']
      },
      {
        title: 'Técnicos',
        icon: 'supervisor_account',
        route: 'tecnicos-index',
        roles: ['admin'],
        offline: false
      },
      {
        title: 'Usuários',
        icon: 'how_to_reg',
        route: 'usuarios-index',
        roles: ['admin'],
        offline: false
      },
      {
        title: 'Estados',
        icon: 'public',
        route: 'estados-index',
        offline: false,
        roles: ['admin', 'auxiliar']
      },
      {
        title: 'Regiões',
        icon: '360',
        route: 'regioes-index',
        offline: false,
        roles: ['admin', 'auxiliar']
      },
      {
        title: 'Cidades',
        icon: 'location_city',
        route: 'cidades-index',
        offline: false,
        roles: ['admin', 'auxiliar']
      }
    ]
  }
]

export default Menu
